module.exports = __webpack_public_path__ + "img/check-circle-blue.1e554e41.svg";